import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import { ChartTemplate } from "../../mapanalysis/chartTemplate";
import { Remove_empty_bins } from "../../helper/remove_empty_bins";

/* 
dc-js chart template 

 */

const cropSuitabilityChartFunc = (divRef, ndx) => {
  // Dimension by crop suitability
    const crop_suitability = ndx.dimension((d) => d.crop_Suitability_Model);

  //  group by count
    const crop_suitability_grp = crop_suitability.group().reduceCount();
  // create an  instance of dc chart class
    const crop_suitability_chart = dc.rowChart(divRef);
    crop_suitability_chart
        .width(300)
        .height(200)
        .elasticX(true)
        .dimension(crop_suitability)
        .group(Remove_empty_bins(crop_suitability_grp, null))
        .margins({ top: 0, right: 20, bottom: 20, left: 100 })
        .transitionDuration(1500);
    crop_suitability_chart.labelOffsetX(-85);
    crop_suitability_chart.xAxis().ticks(5);
  return crop_suitability_chart;
};

export const SuitabilityModel = (props) => (
  <ChartTemplate
    //  pass the chart object as a prop to the chart  function
    chartFunction={cropSuitabilityChartFunc}
    // title="Gender of Finance Recipient"
  />
);
